import Vue from "vue";
import Vuex from "vuex";
import MeStore from "./MeStore";

Vue.use(Vuex)

const store = new Vuex.Store({
	modules: {
		me: MeStore,
		// add more modules here
	}
})

export default store;